import React from 'react';
import ViewportIosContainer from '../../../ios-viewport-container/ios-viewport-container';
import { st, classes } from './action-sheet-modal-mobile-base.st.css';
export const ActionSheetModalMobileBase = ({ dataHook, toggle, isBlackAndWhite = false, children }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.overlay, onClick: toggle }),
        React.createElement(ViewportIosContainer, { preventScroll: false, className: classes.contentContainer },
            React.createElement("div", { className: st(classes.innerContainer, { isBlackAndWhite: isBlackAndWhite === true }), "data-hook": dataHook }, children))));
};
//# sourceMappingURL=action-sheet-modal-mobile-base.js.map